<template>
  <div class="spinner-backdrop-container">
    <template v-if="spinning">
      <div class="spinner-backdrop" />
      <div class="spinner-backdrop-message">
        <i class="far fa-circle-notch spinner"></i>
        <span v-if="message" class="ml-1">{{ message }}</span>
      </div>
    </template>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    message: { type: String, default: "" },
    spinning: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss">
.spinner-backdrop-container {
  position: relative;

  .spinner-backdrop {
    position: absolute;
    z-index: 1009;
    height: 100%;
    width: 100%;
    opacity: 0.5;
    background-color: var(--gray-dark);
  }

  .spinner-backdrop-message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1010;

    padding: 1rem;
    background: var(--white);
    border-radius: 0.3rem;
  }
}
</style>
